/* Edenworth colours
   1. Gallery: photos and videos whose alt text = a colour name only show for that colour.
      Media with another alt text (or none) show for every colour.
   2. Colour picker: round two-tone swatches + "Colour: Racing Green" above.
      Colours come from the product metafield "Swatch colours" (custom.swatches),
      one line per colour: "Mahogany: #7A2E1A, #E6D6BD". Otherwise guessed from the name.
   3. Photos further down the page that come from the product switch to the same shot
      in the chosen colour (same position in that colour's set). */
(function () {
  'use strict';
  function norm(s) { return String(s || '').trim().toLowerCase(); }

  /* colours set in Shopify */
  var SET = {};
  String(window.EW_SWATCH || '').split(/\n+/).forEach(function (line) {
    var i = line.indexOf(':');
    if (i < 1) return;
    var name = norm(line.slice(0, i));
    var hex = line.slice(i + 1).match(/#[0-9a-fA-F]{3,8}/g);
    if (name && hex && hex.length) SET[name] = [hex[0], hex[1] || hex[0]];
  });

  var GOLD = '#C9A66B', SILVER = '#C9CCD0';
  var GOLD_TRIM = /racing|green|emerald|forest|bottle|olive/;
  var PALETTE = [
    [/silver|chrome|steel|platinum/, SILVER],
    [/gold|brass|champagne/, GOLD],
    [/savile|dove|light grey|light gray|ash|fog|mist|pebble/, '#B8B9B6'],
    [/cognac|tobacco|saddle|chestnut|whisky|whiskey/, '#8A4B2A'],
    [/mahogany|rosewood|cherry/, '#7A2E1A'],
    [/terra|rust|copper|brick/, '#B4583A'],
    [/racing|forest|bottle|green|emerald|olive/, '#24493A'],
    [/navy|midnight|ink|admiral/, '#1F2A44'],
    [/blue|cobalt|royal|sapphire/, '#2B4C7E'],
    [/black|noir|onyx|obsidian|ebony|carbon|jet/, '#17181B'],
    [/white|ivory|cream|pearl|alabaster/, '#EFE9DD'],
    [/grey|gray|slate|graphite|gunmetal|charcoal/, '#6F7377'],
    [/brown|tan|walnut|caramel|chocolate/, '#7B4A2A'],
    [/burgundy|wine|oxblood|bordeaux|claret|red/, '#6A1E2A'],
    [/pink|rose|blush/, '#D8A7A7'],
    [/beige|sand|taupe|stone|oat/, '#C8B79B'],
    [/orange|amber/, '#C8662B'],
    [/yellow|mustard|ochre/, '#D6A93A']
  ];
  function pick(text) {
    for (var i = 0; i < PALETTE.length; i++) { if (PALETTE[i][0].test(text)) return PALETTE[i][1]; }
    return null;
  }
  function tones(name) {
    var n = norm(name);
    if (SET[n]) return SET[n];
    var parts = n.split(/\s*(?:&|\/|\+| and | with )\s*/);
    var main = pick(parts[0]) || pick(n) || '#B9B4AA';
    var accent = (parts.length > 1 && pick(parts[1])) || (GOLD_TRIM.test(parts[0]) ? GOLD : SILVER);
    return [main, accent];
  }

  function injectCss() {
    if (document.getElementById('ew-swatch-css')) return;
    var s = document.createElement('style'); s.id = 'ew-swatch-css';
    s.textContent =
      '.ew-sw{display:flex!important;flex-wrap:wrap;gap:1.2rem!important;border:0!important;padding:0!important;margin:0!important}' +
      '.ew-sw legend{width:100%;padding:0!important;margin:0 0 1rem!important;font-size:1.4rem!important;font-weight:500;color:var(--ew-muted,#56575B)!important;letter-spacing:0!important;text-transform:none!important}' +
      '.ew-sw legend b{color:#15171B!important;font-weight:600}' +
      '.ew-sw input[type=radio]{position:absolute!important;opacity:0!important;width:1px!important;height:1px!important}' +
      '.ew-sw input[type=radio]+label{position:relative;width:4.2rem!important;height:4.2rem!important;min-width:0!important;padding:0!important;margin:0!important;border-radius:50%!important;border:0!important;background:linear-gradient(135deg,var(--c1) 0 50%,var(--c2) 50% 100%)!important;box-shadow:inset 0 0 0 1px rgba(21,23,27,.12);font-size:0!important;color:transparent!important;cursor:pointer;transition:transform .15s ease}' +
      '.ew-sw input[type=radio]+label:after{content:"";position:absolute;inset:-5px;border-radius:50%;border:1.5px solid transparent;transition:border-color .15s ease}' +
      '.ew-sw input[type=radio]+label:hover{transform:scale(1.05)}' +
      '.ew-sw input[type=radio]:checked+label:after{border-color:#15171B}' +
      '.ew-sw input[type=radio].disabled+label,.ew-sw input[type=radio]:disabled+label{opacity:.35}' +
      'img.ew-swap{transition:opacity .25s ease}';
    document.head.appendChild(s);
  }

  function colourGroup(root) {
    var groups = root.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      var label = g.querySelector('legend, label.form__label');
      if (label && /colou?r|finish|shade/i.test(label.textContent)) return g;
    }
    return null;
  }

  function decorate(g) {
    if (!g || g.tagName !== 'FIELDSET') return;
    injectCss();
    g.classList.add('ew-sw');
    var legend = g.querySelector('legend');
    var checked = g.querySelector('input[type=radio]:checked');
    if (legend) {
      if (!legend.dataset.ewBase) legend.dataset.ewBase = legend.textContent.replace(/:.*$/, '').trim();
      legend.innerHTML = legend.dataset.ewBase + ': <b></b>';
      legend.querySelector('b').textContent = checked ? checked.value : '';
    }
    g.querySelectorAll('input[type=radio]').forEach(function (r) {
      var lab = g.querySelector('label[for="' + r.id + '"]');
      if (!lab) return;
      var t = tones(r.value);
      lab.style.setProperty('--c1', t[0]);
      lab.style.setProperty('--c2', t[1]);
      lab.title = r.value;
    });
  }

  function state(g) {
    var values = [], current = '';
    g.querySelectorAll('input[type=radio]').forEach(function (r) {
      values.push(norm(r.value));
      if (r.checked) current = norm(r.value);
    });
    var sel = g.querySelector('select');
    if (sel) {
      Array.prototype.forEach.call(sel.options, function (o) { values.push(norm(o.value)); });
      current = norm(sel.value);
    }
    return { values: values, current: current };
  }

  var media = null;
  function fileOf(url) {
    var m = String(url || '').split('?')[0].match(/\/files\/(?:preview_images\/)?([^\/]+)$/);
    return m ? m[1].toLowerCase() : '';
  }
  function loadMedia(gal, cb) {
    if (media) return cb();
    var url = location.pathname.replace(/\/$/, '') + '.js';
    fetch(url).then(function (r) { return r.json(); }).then(function (p) {
      media = (p.media || []).map(function (m) {
        var src = m.media_type === 'image' ? m.src : (m.preview_image && m.preview_image.src);
        return { alt: norm(m.alt), type: m.media_type, src: src || '', file: fileOf(src) };
      });
      var thumbs = gal ? gal.querySelectorAll('.ew-gallery__thumb') : [];
      if (thumbs.length === media.length) {
        thumbs.forEach(function (t, i) { t.setAttribute('data-alt', media[i].alt); });
      }
      cb();
    }).catch(function () { media = []; cb(); });
  }

  function groupOf(colour) { return media.filter(function (m) { return m.alt === colour; }); }
  function imageAt(group, k) {
    if (!group.length) return null;
    for (var i = k; i < group.length; i++) if (group[i].type === 'image') return group[i];
    for (var j = Math.min(k, group.length - 1); j >= 0; j--) if (group[j].type === 'image') return group[j];
    return null;
  }
  function sized(src, w) { return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }

  function swapBelow(root, st) {
    if (!media || !media.length) return;
    var colours = st.values;
    var byFile = {};
    media.forEach(function (m) { if (m.file) byFile[m.file] = m; });
    var target = groupOf(st.current);
    if (!target.length) return;
    document.querySelectorAll('main img, #MainContent img').forEach(function (img) {
      if (img.closest('[data-ew-gallery]') || img.closest('.related-products') || img.closest('product-recommendations')) return;
      var orig = img.dataset.ewOrig;
      if (!orig) {
        var f = fileOf(img.currentSrc || img.src);
        var m = byFile[f];
        if (!m || colours.indexOf(m.alt) === -1) return;
        img.dataset.ewOrig = f;
        orig = f;
      }
      var src0 = byFile[orig];
      if (!src0) return;
      var k = groupOf(src0.alt).indexOf(src0);
      var next = imageAt(target, k);
      if (!next || fileOf(img.currentSrc || img.src) === next.file) return;
      img.classList.add('ew-swap');
      img.setAttribute('srcset', sized(next.src, 700) + ' 700w, ' + sized(next.src, 1100) + ' 1100w, ' + sized(next.src, 1600) + ' 1600w');
      img.src = sized(next.src, 1100);
    });
  }

  function show(t, on) { t.style.display = on ? '' : 'none'; }
  function filter(root) {
    var gal = root.querySelector('[data-ew-gallery]');
    var g = colourGroup(root);
    if (!g) return;
    var st = state(g);
    if (!st.current) return;
    swapBelow(root, st);
    if (!gal) return;
    var thumbs = gal.querySelectorAll('.ew-gallery__thumb');
    var any = false;
    thumbs.forEach(function (t) { if (norm(t.getAttribute('data-alt')) === st.current) any = true; });
    if (!any) { thumbs.forEach(function (t) { show(t, true); }); return; }
    var first = null;
    thumbs.forEach(function (t) {
      var tag = norm(t.getAttribute('data-alt'));
      var isColour = st.values.indexOf(tag) !== -1;
      var on = !isColour || tag === st.current;
      show(t, on);
      if (on && tag === st.current && !first) first = t;
    });
    if (first && gal.dataset.ewColour !== st.current) {
      gal.dataset.ewColour = st.current;
      first.click();
    }
  }

  function run(root) {
    decorate(colourGroup(root));
    loadMedia(root.querySelector('[data-ew-gallery]'), function () { filter(root); });
  }

  function init() {
    document.querySelectorAll('.ew-pdp').forEach(function (root) {
      run(root);
      if (root.dataset.ewVar) return; root.dataset.ewVar = '1';
      root.addEventListener('change', function (e) {
        if (!e.target.closest('variant-selects')) return;
        decorate(colourGroup(root));
        setTimeout(function () { run(root); }, 60);
        setTimeout(function () { run(root); }, 700);
      });
      var vs = root.querySelector('product-info') || root;
      new MutationObserver(function () {
        var g = colourGroup(root);
        if (g && !g.classList.contains('ew-sw')) decorate(g);
      }).observe(vs, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();